import {Card, Group, Stack, Text, Title} from '@mantine/core'
import {IconUser, IconUsers} from '@tabler/icons-react'
import {createFileRoute, Link} from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/admin/')({
    component: AdminHomePage,
})

function AdminHomePage() {
    return (
        <Stack gap="lg">
            <Title order={3}>Admin</Title>
            <Group>
                <Card
                    component={Link}
                    to="/admin/organizations"
                    withBorder
                    padding="lg"
                    style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        minWidth: 200,
                        cursor: 'pointer',
                    }}
                >
                    <Stack gap="xs">
                        <IconUsers size={32} />
                        <Text fw={500}>View Organizations</Text>
                        <Text size="sm" c="dimmed">
                            Manage organizations, users, and data
                        </Text>
                    </Stack>
                </Card>
                <Card
                    component={Link}
                    to="/admin/users"
                    withBorder
                    padding="lg"
                    style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        minWidth: 200,
                        cursor: 'pointer',
                    }}
                >
                    <Stack gap="xs">
                        <IconUser size={32} />
                        <Text fw={500}>View Admin Users</Text>
                        <Text size="sm" c="dimmed">
                            Manage all internal admin users
                        </Text>
                    </Stack>
                </Card>
            </Group>
        </Stack>
    )
}
